import {SealLogoPositionEnum} from '@sdox/api'
import {LazyImage, RichText} from '@sdox/ui'
import {twMerge} from '@sdox/utils'

import type {LazyImageProps} from '@sdox/ui'
import type {XcNwBlock_BlockSeQualityDescriptionType_Fragment} from '@sdox/api'

export const BlockSeQualityDescription = (
  props: XcNwBlock_BlockSeQualityDescriptionType_Fragment,
) => {
  const {description, logo, logoPosition} = props

  const Logo = (imageProps: LazyImageProps) =>
    logo ? (
      <LazyImage
        src={logo.thumbnailUrl}
        placeholderSrc={logo.thumbnailUrl380x380 ?? undefined}
        alt={'Siegel'}
        hasBackground={false}
        {...imageProps}
      />
    ) : null

  return (
    <div
      className={twMerge(
        'flex flex-col items-center justify-center',
        logoPosition === SealLogoPositionEnum.Left && 'sm:flex-row',
      )}
    >
      {logoPosition === SealLogoPositionEnum.Left && (
        <Logo className={'mb-3 block w-full sm:mb-0 sm:mr-3 sm:w-64'} />
      )}
      {description && <RichText content={description} />}
      {logoPosition === SealLogoPositionEnum.Bottom && <Logo />}
    </div>
  )
}
